import React from "react";
import Routers from './route.js'
import { useRoutes } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./ScrollToTop/ScrollToTop.js";
import PreventInspect from "DisableDownload/DisableDownload.js";
import { Toaster } from "sonner";

export default function App() {

  let DataRouters = useRoutes(Routers)

  return (
    <div className="antialiased">
      <ScrollToTop />
       <PreventInspect/> 
      {DataRouters}
      <Toaster position="top-center" closeButton={true} dir="rtl"  />
    </div>
  )
}